// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import { useAppContext } from './AppContext'
import React from 'react'

export default function ErrorMessage() {
    const app = useAppContext()

    if (app.error) {
        return (
            <>
                <p className="mb-3">{app.error.message}</p>
                {app.error.debug ? <p>{app.error.debug}</p> : null}
            </>
        )
    }

    return null
}
